import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DndModule } from 'ngx-drag-drop';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { ClickOutsideModule } from '../../directives';
import { TooltipModule } from '../tooltip';

import { ColumnOptionDropComponent } from './column-option-drop.component';

@NgModule({
  declarations: [ColumnOptionDropComponent],
  exports: [ColumnOptionDropComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgScrollbarModule,
    DndModule,
    NzCheckboxModule,
    NzIconModule,
    NzToolTipModule,
    ClickOutsideModule,
    TooltipModule
  ]
})
export class ColumnOptionDropModule { }
